// ADV-270 — "Rückruf vereinbaren": the callback time windows offered as chips.
//
// One-hour windows inside the opening hours the page shows under "Direkt erreichbar"
// (Mo–Fr 8–20 Uhr, Sa 9–16 Uhr, Sunday closed). The nearest two windows of today come first
// (from the next full hour), then the next opening day from 09:00 every two hours, four chips in
// all. At 15:xx on a weekday that is Figma's set: Heute 16–17 / 17–18, Morgen 09–10 / 11–12.
/** [first hour, closing hour] per weekday (Date#getDay), null = closed */
const OPENING_HOURS = [null, [8, 20], [8, 20], [8, 20], [8, 20], [8, 20], [9, 16]];
const TODAY_SLOTS = 2;
const NEXT_DAY_STARTS = [9, 11, 13, 15];
export const CALLBACK_SLOT_COUNT = 4;
const atHour = (day, hour) => new Date(day.getFullYear(), day.getMonth(), day.getDate(), hour);
const slotAt = (day, hour, kind) => ({
    start: atHour(day, hour),
    end: atHour(day, hour + 1),
    day: kind,
});
export const getCallbackSlots = (now) => {
    const slots = [];
    const today = OPENING_HOURS[now.getDay()];
    if (today) {
        const nextFullHour = now.getHours() + (now.getMinutes() || now.getSeconds() || now.getMilliseconds() ? 1 : 0);
        for (let hour = Math.max(nextFullHour, today[0]); hour + 1 <= today[1] && slots.length < TODAY_SLOTS; hour += 1) {
            slots.push(slotAt(now, hour, 'today'));
        }
    }
    // the next opening day (Saturday evening → Monday)
    const next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    let daysAhead = 1;
    while (!OPENING_HOURS[next.getDay()]) {
        next.setDate(next.getDate() + 1);
        daysAhead += 1;
    }
    const [open, close] = OPENING_HOURS[next.getDay()];
    const kind = daysAhead === 1 ? 'tomorrow' : 'later';
    NEXT_DAY_STARTS
        .filter((hour) => hour >= open && hour + 1 <= close)
        .forEach((hour) => {
        if (slots.length < CALLBACK_SLOT_COUNT)
            slots.push(slotAt(next, hour, kind));
    });
    return slots;
};
const twoDigits = (n) => (n < 10 ? `0${n}` : String(n));
/** "16:00–17:00" (en dash, as in Figma) */
export const formatSlotTime = ({ start, end }) => `${twoDigits(start.getHours())}:${twoDigits(start.getMinutes())}–${twoDigits(end.getHours())}:${twoDigits(end.getMinutes())}`;
